export const products = [
  {
    //귀걸이

    id: 100,
    name: "14K 레이어드 피어싱 105종 모음전",
    primeCategory: "jewelry",
    subCategory: "earing",
    description: "234",
    price: 27800,
    discount: 71,
    companyId: 5000,
    companyName: "abc사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/QspnSsWwFpk/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjIxMjA3XzE2NzAzODE2NjU3MzE0OTZtLmpwZw",
    totalSales: 756,
  },
  {
    id: 101,
    name: "러블리 하트 귀걸이",
    primeCategory: "jewelry",
    subCategory: "earing",
    description: "234",
    price: 28800,
    discount: 30,
    companyId: 5001,
    companyName: "a사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/CQX3Eu_3irg/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjQwOTE2XzE3MjY0OTYwOTI2MTk1NDJtLmpwZw",
    totalSales: 5948,
  },
  {
    id: 102,
    name: "유리알 귀걸이",
    primeCategory: "jewelry",
    subCategory: "earing",
    description: "234",
    price: 27800,
    discount: 71,
    companyId: 5002,
    companyName: "b사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/o02dyzgxEGY/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjQwOTE2XzE3MjY0OTU5NTQ5MjgyNzFtLmpwZw",
    totalSales: 346,
  },
  {
    id: 103,
    name: "하트큐빅 귀걸이",
    primeCategory: "jewelry",
    subCategory: "earing",
    description: "234",
    price: 27800,
    discount: 71,
    companyId: 5001,
    companyName: "a사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/V_UGWhHjEOg/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjQwMTEzXzE3MDUxMTE5Mjc1NDUzNzZtLmpwZw",

    totalSales: 8549,
  },
  {
    id: 104,
    name: "원터치 링 귀걸이",
    primeCategory: "jewelry",
    subCategory: "earing",
    description: "234",
    price: 27800,
    discount: 71,
    companyId: 5001,
    companyName: "a사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/aY4fDrOyk9c/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzRiZTE0ZDc2M2ZhYTlmZDRkNzAzYWFiNmQyN2JkZTgxLmpwZw",
    totalSales: 5946,
  },

  //목걸이
  {
    id: 200,
    name: "스완목걸이",
    primeCategory: "jewelry",
    subCategory: "necklace",
    description: "234",
    price: 15000,
    discount: 50,
    companyId: 5003,
    companyName: "c사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/zJ-zReUjSVk/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzL2IxNGNlYTBmZDUwNTU3ODAwMzgxMDUxZWZjNTZhZmUxLmpwZw",
    totalSales: 2541,
  },
  {
    id: 201,
    name: "리본목걸이",
    primeCategory: "jewelry",
    subCategory: "necklace",
    description: "234",
    price: 27800,
    discount: 71,
    companyId: 5002,
    companyName: "b사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/sxYudrkXg0E/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjQwOTE2XzE3MjY0OTgzNTAxNjcxOThtLmpwZw",
    totalSales: 2500,
  },
  {
    id: 202,
    name: "클로버목걸이",
    primeCategory: "jewelry",
    subCategory: "necklace",
    description: "234",
    price: 27800,
    discount: 71,
    companyId: 5001,
    companyName: "a사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/0uMscurnkiM/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjMxMDEzXzE2OTcxODI0OTAyNTgwOTFtLmpwZw",
    totalSales: 300,
  },
  {
    id: 203,
    name: "투명 원석 목걸이",
    primeCategory: "jewelry",
    subCategory: "necklace",
    description: "234",
    price: 27800,
    discount: 71,
    companyId: 5003,
    companyName: "c사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/t2nMqbUoUQY/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjQwOTE2XzE3MjY0NjgzNzAxMDc0MDZtLmpwZw",
    totalSales: 100,
  },
  {
    id: 204,
    name: "원형 링 목걸이",
    primeCategory: "jewelry",
    subCategory: "necklace",
    description: "234",
    price: 30000,
    discount: 30,
    companyId: 5001,
    companyName: "a사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/R-tYOSyxaG8/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjQwOTE2XzE3MjY0Nzg5NzAxMTQ4NzRtLmpwZw",
    totalSales: 2500,
  },
  {
    id: 205,
    name: "[silver925] 데일리실버목걸이 은목걸이",
    primeCategory: "jewelry",
    subCategory: "necklace",
    description: "블링블링 합니다",
    price: 7000,
    discount: 16,
    companyId: 5001,
    companyName: "a사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/juA804KTY40/pr:NEW_GOODS_THUMB_WEBP/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzAwZjYzMDk3MDRjMGFiM2Q5YjViMWZhMDViYzQwY2M3LmdpZg",
    totalSales: 2454,
  },
  {
    id: 206,
    name: "당일출고[써지컬75종]변색X알러지X",
    primeCategory: "jewelry",
    subCategory: "necklace",
    description: "변색 없습니다. 변상도 없습니다.",
    price: 18000,
    discount: 51,
    companyId: 5002,
    companyName: "b사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/KAhKQKNJfHQ/pr:NEW_GOODS_THUMB_WEBP/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjEwNjA0XzE2MjI3ODMwMDk1Nzk2MDRzLmdpZg",
  },
  {
    id: 207,
    name: "특가![숏&롱/가을팬츠/히든밴딩] 넛츠 하이",
    primeCategory: "jewelry",
    subCategory: "necklace",
    description: "호핑호핑",
    price: 15500,
    discount: 0,
    companyId: 5002,
    companyName: "b사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/Ho07fUXHZo8/pr:NEW_GOODS_THUMB_WEBP/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzL2QyYTk3MzZmZGQzMWE1MTRjZjliYmU3MGYyZTlhNmQyLmdpZg",
  },
  //반지
  {
    id: 300,
    name: "🦋 Carinabe 나비반지 2colors 🦋 우정반지 우정템 우정링",
    primeCategory: "jewerly",
    subCategory: "ring",
    description: "마치 에스파의 멤버 '카리나'를 연상케 하는 카리나비반지 🦋",
    price: 19900,
    discount: 30,
    companyId: 5003,
    companyName: "c사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/vD4o_uwy9fQ/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjQwOTAzXzE3MjUzNDI3OTI2OTU4NjRtLmpwZw",
    totalSales: 7421,
  },
  {
    id: 301,
    name: "오늘출발/(각인)18k 하이퀄리티 코코 퀄팅 볼드반지",
    primeCategory: "jewerly",
    subCategory: "ring",
    description:
      "엠보 퀄팅 디테일의 세련되면서도 고급스러운 무드를 가진 반지를 소개할게요. 데일리로 부담없이 착용하기 좋은 제품이에요",
    price: 60000,
    discount: 46,
    companyId: 5003,
    companyName: "c사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/zU5MkEmNmZ0/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjQwODEwXzE3MjMyODMxNjQyNzI4MTFtLmpwZw",
    totalSales: 1623,
  },
  {
    id: 302,
    name: "[made] 섬광 각인 볼드 웨이브 오픈 링 반지",
    primeCategory: "jewerly",
    subCategory: "ring",
    description:
      "소재 / 신주 + 도금 사이즈 / 오픈링으로 사이즈 조절 가능 **내구성이 다소 강한 소재의 반지로 사이즈 조절 시 다소 힘을 주어 조정 해주셔야 합니다 예민하신 분은 신중한 구매 부탁드립니다 :)",
    price: 11400,
    discount: 5,
    companyId: 5002,
    companyName: "b사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/GqTQoCP9zCA/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjQwNjAyXzE3MTczMDg4NjUwMTIyMzhtLmpwZw",
    totalSales: 24000,
  },
  {
    id: 303,
    name: "오늘출발(각인) high quality 18k 콰트로 반지",
    primeCategory: "jewerly",
    subCategory: "ring",
    description: "요즘 핫하면서 유행타지 않은 디자인 콰트로 링을 가져왔어요.",
    price: 70000,
    discount: 50,
    companyId: 5001,
    companyName: "a사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/UrmT6opkAA8/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjQwOTE1XzE3MjYzOTY5MzgxNTU3NzhtLmpwZw",
    totalSales: 1623,
  },
  {
    id: 304,
    name: "은커플링 실버반지 우정반지 돌체",
    primeCategory: "jewerly",
    subCategory: "ring",
    description:
      "심플한 디자인의 윤곽이 멋스러운 길리 입니다. 여성 반지에는 메인스톤과 서브스톤을 세팅하여 화려하지만 절제된 아름다움을 느끼게 해줍니다. 남성 반지에는 큐빅없이 라인을 강조해 부드럽고 세련된 느낌을 줍니다. 남여 디자인 구분없이, 취향에 맞는 제품을 선택 하시면 좋습니다.",
    price: 130000,
    discount: 50,
    companyId: 5004,
    companyName: "d사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/WL765C-Xo_E/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjQwODE0XzE3MjM2MzE2MjgwNTQ2MzltLmpwZw",
    totalSales: 7421,
  },

  //팔찌
  {
    id: 400,
    name: "실버925 마린 문양 팔찌",
    primeCategory: "jewerly",
    subCategory: "bracelet",
    description:
      "심플한 디자인의 윤곽이 멋스러운 길리 입니다. 여성 반지에는 메인스톤과 서브스톤을 세팅하여 화려하지만 절제된 아름다움을 느끼게 해줍니다. 남성 반지에는 큐빅없이 라인을 강조해 부드럽고 세련된 느낌을 줍니다. 남여 디자인 구분없이, 취향에 맞는 제품을 선택 하시면 좋습니다.",
    price: 130000,
    discount: 50,
    companyId: 5001,
    companyName: "a사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/Pq0ooJ4wCZQ/pr:NEW_GOODS_THUMB_WEBP/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzYxZTI1YmU0MTBlYThlMmI5MDc4ZjgwYTgwYTgxZmViLmpwZw",
    totalSales: 7421,
  },
  {
    id: 401,
    name: "주얼리 스타 팔찌",
    primeCategory: "jewerly",
    subCategory: "bracelet",
    description:
      "심플한 디자인의 윤곽이 멋스러운 길리 입니다. 여성 반지에는 메인스톤과 서브스톤을 세팅하여 화려하지만 절제된 아름다움을 느끼게 해줍니다. 남성 반지에는 큐빅없이 라인을 강조해 부드럽고 세련된 느낌을 줍니다. 남여 디자인 구분없이, 취향에 맞는 제품을 선택 하시면 좋습니다.",
    price: 130000,
    discount: 50,
    companyId: 5001,
    companyName: "a사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/Wrjht5MnZcY/pr:NEW_GOODS_THUMB_WEBP/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzc0ZjBjYTQxYTZkNjFkNDk5YjQwOWY0N2ZhNDIzMTg4LmpwZWc",
    totalSales: 7421,
  },
  {
    id: 402,
    name: "[써지컬] 동글리본 팔찌/발찌",
    primeCategory: "jewerly",
    subCategory: "bracelet",
    description:
      "심플한 디자인의 윤곽이 멋스러운 길리 입니다. 여성 반지에는 메인스톤과 서브스톤을 세팅하여 화려하지만 절제된 아름다움을 느끼게 해줍니다. 남성 반지에는 큐빅없이 라인을 강조해 부드럽고 세련된 느낌을 줍니다. 남여 디자인 구분없이, 취향에 맞는 제품을 선택 하시면 좋습니다.",
    price: 130000,
    discount: 50,
    companyId: 5001,
    companyName: "a사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/eb-gVQQQZmg/pr:NEW_GOODS_THUMB_WEBP/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzQxYjE2MTE5NzcxMzRmZDgzZmZjMWY4M2RlMDc5OTAwLmpwZw",
    totalSales: 7421,
  },
  {
    id: 403,
    name: "크롬하츠마블원석팔찌",
    primeCategory: "jewerly",
    subCategory: "bracelet",
    description:
      "심플한 디자인의 윤곽이 멋스러운 길리 입니다. 여성 반지에는 메인스톤과 서브스톤을 세팅하여 화려하지만 절제된 아름다움을 느끼게 해줍니다. 남성 반지에는 큐빅없이 라인을 강조해 부드럽고 세련된 느낌을 줍니다. 남여 디자인 구분없이, 취향에 맞는 제품을 선택 하시면 좋습니다.",
    price: 130000,
    discount: 50,
    companyId: 5001,
    companyName: "a사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/Ib_FEXZcrgU/pr:NEW_GOODS_THUMB_WEBP/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzL2U3MTY2NWUxMWVkZTZmMGZjNGU5MjE1OTQ1NDNhMzRkLmpwZWc",
    totalSales: 7421,
  },
  {
    id: 404,
    name: "오닉스 옥 만자 실버925 펜던트 은볼 팔찌",
    primeCategory: "jewerly",
    subCategory: "bracelet",
    description:
      "심플한 디자인의 윤곽이 멋스러운 길리 입니다. 여성 반지에는 메인스톤과 서브스톤을 세팅하여 화려하지만 절제된 아름다움을 느끼게 해줍니다. 남성 반지에는 큐빅없이 라인을 강조해 부드럽고 세련된 느낌을 줍니다. 남여 디자인 구분없이, 취향에 맞는 제품을 선택 하시면 좋습니다.",
    price: 130000,
    discount: 50,
    companyId: 5004,
    companyName: "d사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/TZJ3FjfHdBg/pr:NEW_GOODS_THUMB_WEBP/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzL2MyMzAyODlmNWI1MTA3ZDM1YjY2OTMyOGVjN2M2N2E0LmpwZw",
    totalSales: 7421,
  },

  //발찌
  {
    id: 501,
    name: "여성용 럭키 패션 발찌",
    primeCategory: "jewerly",
    subCategory: "anklet",
    description: "행운 상승.",
    price: 16000,
    discount: 10,
    companyId: 5002,
    companyName: "b사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/5JMpy4dIs70/pr:NEW_GOODS_THUMB_WEBP/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzYzNzI5MzI0ODhkZmVjYjE4OGRlYTA2ODNkZTA1ZDdlLmpwZw",
    totalSales: 4946,
  },
  {
    id: 502,
    name: "하트 발찌",
    primeCategory: "jewerly",
    subCategory: "anklet",
    description: "하트 모양 장식이 있습니다.",
    price: 14000,
    discount: 30,
    companyId: 5002,
    companyName: "b사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/2lzLkBN_9uQ/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjQwODI0XzE3MjQ0Njc4NTcxOTgxMTdtLmpwZw",
    totalSales: 2642,
  },
  {
    id: 503,
    name: "큐브 발찌",
    primeCategory: "jewerly",
    subCategory: "anklet",
    description: "실버 제품입니다.",
    price: 20000,
    discount: 20,
    companyId: 5001,
    companyName: "a사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/lY0BTP-H9RY/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjEwNzA1XzE2MjU0OTU1MTc3NzQwOTNtLmpwZw",
    totalSales: 2975,
  },
  {
    id: 504,
    name: "다이아몬드 발찌",
    primeCategory: "jewerly",
    subCategory: "anklet",
    description: "튼튼해서 잘 안 끊어집니다.",
    price: 16000,
    discount: 15,
    companyId: 5003,
    companyName: "c사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/YqK40XToa_M/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjEwNjA5XzE2MjMxOTMxMzkzOTQyODhtLmpwZw",
    totalSales: 1782,
  },
  {
    id: 505,
    name: "야광 발찌",
    primeCategory: "jewerly",
    subCategory: "anklet",
    description: "밤에도 잘 보입니다",
    price: 30000,
    discount: 10,
    companyId: 5004,
    companyName: "d사",
    imgSrc:
      "https://thumbnail6.coupangcdn.com/thumbnails/remote/292x292q65ex/image/vendor_inventory/2e04/d6b5a115baf35b52f94af4f9b557d999ee44b9ebfaf3790e93f12225e2c4.jpg",
    totalSales: 5642,
  },

  {
    id: 601,
    name: "투명 보석함",
    primeCategory: "jewelry",
    subCategory: "jewelry-box",
    description: "신상 비즈 다꾸 악세서리 보관 케이스",
    price: 6500,
    discount: 0,
    companyId: 5001,
    companyName: "a사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/pO0n-nsCo0Q/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjQwOTE2XzE3MjY0OTgzNjE4MzAzOTltLmpwZw",
    totalSales: 3456,
  },
  {
    id: 602,
    name: "키티 보석함",
    primeCategory: "jewelry",
    subCategory: "jewelry-box",
    description: "당일 출고! 키티 보석함",
    price: 14000,
    discount: 10,
    companyId: 5002,
    companyName: "b사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/XuPIRGs4jGc/pr:NEW_GOODS_THUMB_WEBP/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzg2Y2Q3Yzg4MzVjNGYxYzE1Zjg2YWZhNmRkMjdmZjM2LkdJRg",
    totalSales: 3803,
  },
  {
    id: 603,
    name: "원형 보석함",
    primeCategory: "jewelry",
    subCategory: "jewelry-box",
    description: "쿠키통으로 사용할 수도 있어요",
    price: 4600,
    discount: 0,
    companyId: 5003,
    companyName: "c사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/tGIKFJygW0U/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjMwMjAyXzE2NzUzMjIxMjk5OTk2ODltLmpwZw",
    totalSales: 5135,
  },
  {
    id: 604,
    name: "3단 보석함",
    primeCategory: "jewelry",
    subCategory: "jewelry-box",
    description: "3단 투명 보석함 쥬얼리 보관함 박스",
    price: 22900,
    discount: 30,
    companyId: 5001,
    companyName: "a사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/E-bD5zS1SHM/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjQwNDA0XzE3MTIyMjEwMTA5ODI5OTVtLmpwZw",
    totalSales: 779,
  },
  {
    id: 605,
    name: "크리스탈 보석함",
    primeCategory: "jewelry",
    subCategory: "jewelry-box",
    description: "두가지 size",
    price: 7700,
    discount: 10,
    companyId: 5002,
    companyName: "b사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/zDu3Guo_H8A/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjEwNzEzXzE2MjYxNjM0NDUxODYwMDBtLmpwZw",
    totalSales: 2289,
  },
  {
    id: 606,
    name: "휴대용 보석함",
    primeCategory: "jewelry",
    subCategory: "jewelry-box",
    description: "가볍고 튼튼해요",
    price: 10000,
    discount: 40,
    companyId: 5001,
    companyName: "a사",
    imgSrc:
      "https://d3ha2047wt6x28.cloudfront.net/4GCuBAVVnJc/pr:GOODS_DETAIL/czM6Ly9hYmx5LWltYWdlLWxlZ2FjeS9kYXRhL2dvb2RzLzIwMjQwNzMwXzE3MjIzMTU0ODI4NzIwNDNtLmpwZw",
    totalSales: 4242,
  },
];
